<script setup lang="ts">
  import moment from "moment";
  import IndexTableEmpty from "./IndexTableEmpty.vue";

  const props = withDefaults(defineProps<{ date?: string | null; format?: string }>(), { date: null, format: "MMM YY" });
</script>

<template>
  <span
    v-if="props.date"
    class="whitespace-nowrap text-muted-foreground">
    {{ moment(props.date).format(props.format) }}
  </span>
  <IndexTableEmpty v-else />
</template>
